import EditDenimProduct from "./EditDenimProduct";
import HorizontalProducts from "./HorizontalProducts";
import ProductHeader from "./ProductHeader";
import WashTabs from "./WashTabs";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";

const DenimProduct = ({
  oneProduct,
  editMode,
  setEditMode,
  totalLook,
  similarProducts,
  isLoadingTotalLook,
  isLoadingSimilar,
}: any) => {
  return !editMode ? (
    <>
      <ProductHeader
        oneProduct={oneProduct}
        setEditMode={setEditMode}
        editMode={editMode}
      />
      <div className="details">
        <div className="details_fabric">
          <div>
            <h3 className="fabric_title">Fabric</h3>
            {oneProduct && oneProduct.fabric_details && (
              <p className="paragraphe fabric_text ">
                {oneProduct.fabric_details}
              </p>
            )}
          </div>

          <table className="fabric-table-details" style={{ width: "100%" }}>
            <tbody>
              {oneProduct && oneProduct?.fabric_chars?.length > 0 && (
                <tr>
                  <th>Fabric Type</th>
                  {oneProduct && (
                    <td>
                      {oneProduct?.fabric_chars?.length > 0 &&
                        oneProduct.fabric_chars.map((el: any, key: number) =>
                          key === oneProduct?.fabric_chars?.length - 1
                            ? `${el.name}`
                            : `${el.name} • `
                        )}
                    </td>
                  )}
                </tr>
              )}
              {oneProduct && oneProduct.fabric_composition && (
                <tr>
                  <th>Composition</th>
                  {oneProduct && (
                    <td className="pr-5">{oneProduct.fabric_composition}</td>
                  )}
                </tr>
              )}
              <tr>
                {oneProduct && oneProduct.elasticity !== null && (
                  <>
                    <th>Elasticity</th>
                    <td>
                      {oneProduct.elasticity === 0
                        ? `Rigid`
                        : Math.floor(oneProduct.elasticity * 100) > 0 &&
                          Math.floor(oneProduct.elasticity * 100) <= 25
                        ? `${Math.floor(oneProduct.elasticity * 100)}% Comfort`
                        : Math.floor(oneProduct.elasticity * 100) >= 26 &&
                          Math.floor(oneProduct.elasticity * 100) <= 45
                        ? `${Math.floor(oneProduct.elasticity * 100)}% Stretch`
                        : Math.floor(oneProduct.elasticity * 100) >= 46 &&
                          Math.floor(oneProduct.elasticity * 100) <= 75
                        ? `${Math.floor(
                            oneProduct.elasticity * 100
                          )}% Power stretch`
                        : Math.floor(oneProduct.elasticity * 100) >= 76 &&
                          Math.floor(oneProduct.elasticity * 100) <= 100 &&
                          `${Math.floor(
                            oneProduct.elasticity * 100
                          )}% Hyper stretch`}
                    </td>
                  </>
                )}
              </tr>

              {oneProduct &&
                oneProduct?.fabric_chars?.length > 0 &&
                oneProduct.fabric_chars[0].weight && (
                  <tr>
                    <th>Weight</th>
                    {oneProduct.fabric_type === "denim" &&
                      oneProduct.fabric_chars.length > 0 && (
                        <td>
                          {oneProduct.fabric_chars.length > 1
                            ? oneProduct.fabric_chars.map(
                                (el: any, key: number) =>
                                  key === oneProduct.fabric_chars.length - 1
                                    ? `${el.name} ${el.weight}oz`
                                    : `${el.name} ${el.weight}oz • `
                              )
                            : `${oneProduct.fabric_chars[0].weight} oz`}
                        </td>
                      )}
                  </tr>
                )}

              {oneProduct && oneProduct.fabric_price !== 0 && (
                <tr>
                  <th>Price</th>
                  {oneProduct?.fabric_chars?.length > 0 && (
                    <td>
                      {oneProduct?.fabric_chars?.length > 1
                        ? oneProduct?.fabric_chars?.map(
                            (el: any, key: number) =>
                              key === oneProduct.fabric_chars.length - 1
                                ? `${el.name} ${Math.fround(el.price).toFixed(
                                    2
                                  )}€`
                                : `${el.name} ${Math.fround(el.price).toFixed(
                                    2
                                  )}€ • `
                          )
                        : `${Math.fround(
                            oneProduct.fabric_chars[0].price
                          ).toFixed(2)}€`}
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* {tech && oneProduct.technic_id && (
          <div className="details_wash my-4">
            <h3 className="wash_title mb-2">Technique</h3>
            <table style={{ maxWidth: 590 }}>
              <tbody>
                <tr>
                  <th>Technique 1</th>
                  <td>{tech.name}</td>
                  <td>{tech.price}€</td>
                </tr>
              </tbody>
            </table>
          </div>
        )} */}

        {/* DO NOT DELETE !!!! */}

        {oneProduct &&
          oneProduct?.techniques &&
          oneProduct?.techniques?.length !== 0 && (
            <div className="details_wash">
              <h3 className="wash_title mb-2">Technique</h3>
              <table style={{ width: "100%" }}>
                <tbody>
                  {oneProduct.techniques.map((el: any, i: number) => (
                    <tr key={i}>
                      <th>Technique {i + 1}</th>
                      <td>{el.name}</td>
                      <td>PRICE: {`${Math.fround(el.price).toFixed(2)}€`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        {oneProduct &&
          oneProduct?.accessories &&
          oneProduct?.accessories?.length !== 0 && (
            <div className="details_wash">
              <h3 className="wash_title mb-2">Accessories </h3>
              <table style={{ width: "100%" }}>
                <tbody>
                  {oneProduct.accessories.map((el: any, i: number) => (
                    <tr key={i}>
                      <th>Accessory {i + 1}</th>
                      <td>{el.name}</td>
                      <td>PRICE: {`${Math.fround(el.price).toFixed(2)}€`}</td>
                      <td>Unit: {el.unit ? "Per " + el.unit : "-"} </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        {oneProduct && !oneProduct?.with_options ? (
          <>
            <div
              className="details_wash"
              style={
                oneProduct &&
                (oneProduct?.eim_Score ||
                  oneProduct?.washes?.length ||
                  oneProduct?.colors?.length > 0)
                  ? {}
                  : { display: "none" }
              }
            >
              <h3 className="wash_title mb-2">Wash</h3>
              {oneProduct && (
                <div className="wash-details-part d-flex flex-column align-items-stretch">
                  <div className="d-flex">
                    <div className="wash-cell-title border p-3">
                      <h6 className="mb-0">Wash Type / Dye</h6>
                    </div>
                    <div className="details-part d-flex">
                      {oneProduct?.washes?.map((wash: any, index: number) => (
                        <div
                          key={index}
                          className="wash-cell-value p-3 pr-0 border-top border-right border-bottom"
                          style={{
                            minWidth: `calc(100% / ${oneProduct?.washes?.length})`,
                          }}
                        >
                          <p className="mb-0">{wash?.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="wash-cell-title border-left border-right border-bottom p-3">
                      <h6 className="mb-0">Wash Description</h6>
                    </div>
                    <div className="details-part d-flex">
                      {oneProduct?.washes?.map((wash: any, index: number) => (
                        <div
                          key={index}
                          className="wash-cell-value p-3 pr-0 border-right border-bottom"
                          style={{
                            minWidth: `calc(100% / ${oneProduct?.washes?.length})`,
                          }}
                        >
                          <p className="mb-0">{wash?.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="wash-cell-title border-left border-right border-bottom p-3">
                      <h6 className="mb-0">Colour</h6>
                    </div>
                    <div className="details-part d-flex">
                      {oneProduct?.washes?.map((wash: any, index: number) => (
                        <div
                          key={index}
                          className="wash-cell-value p-3 pr-0 border-right border-bottom"
                          style={{
                            minWidth: `calc(100% / ${oneProduct?.washes?.length})`,
                          }}
                        >
                          {wash.colors &&
                            wash?.colors?.map((color: any, i: number) =>
                              i === wash?.colors?.length - 1 ? (
                                <span key={i + index}>{color?.name || ""}</span>
                              ) : (
                                <span key={i + index}>
                                  {color?.name + " • "}
                                </span>
                              )
                            )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="wash-cell-title border-left border-right border-bottom p-3">
                      <h6 className="mb-0">EIM Score</h6>
                    </div>
                    <div className="details-part d-flex">
                      {oneProduct?.washes?.map((wash: any, index: number) => (
                        <div
                          key={index}
                          className="wash-cell-value p-3 pr-0 border-right border-bottom"
                          style={{
                            minWidth: `calc(100% / ${oneProduct?.washes?.length})`,
                          }}
                        >
                          <p className="mb-0">{wash?.eim_score}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="wash-cell-title border-left border-right border-bottom p-3">
                      <h6 className="mb-0">Price</h6>
                    </div>
                    <div className="details-part d-flex">
                      {oneProduct?.washes?.map((wash: any, index: number) => (
                        <div
                          key={index}
                          className="wash-cell-value p-3 pr-0 border-right border-bottom"
                          style={{
                            minWidth: `calc(100% / ${oneProduct.washes.length})`,
                          }}
                        >
                          <p className="mb-0">
                            {Math.fround(wash.wash_price).toFixed(2)}€
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {/* <div
                style={{
                  display: "flex",
                }}
              >
                <table>
                  <tr>
                    <th>Wash Type / Dye</th>
                  </tr>
                  <tr>
                    <th>Wash Description</th>
                  </tr>
                  <tr>
                    <th>Colour</th>
                  </tr>
                  <tr>
                    <th>EIM Score</th>
                  </tr>
                  <tr>
                    <th>Price</th>
                  </tr>
                </table>
                {oneProduct &&
                  oneProduct.washes.map((wash: any, index: number) => (
                    <table>
                      <tr>
                        <td style={{ height: "49px" }}>{wash.name}</td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            wordBreak: "break-word",
                          }}
                        >
                          {wash.description}
                        </td>
                      </tr>
                      {wash.colors && (
                        <tr>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {wash.colors.map((color: any, i: number) =>
                              i === wash.colors.length - 1 ? (
                                <span key={i + index}>{color?.name || ""}</span>
                              ) : (
                                <span key={i + index}>
                                  {color?.name + " • "}
                                </span>
                              )
                            )}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td style={{ height: "49px" }}>{wash.eim_score}</td>
                      </tr>
                      <tr>
                        <td style={{ height: "49px" }}>
                          {Math.fround(wash.wash_price).toFixed(2)}€
                        </td>
                      </tr>
                    </table>
                  ))}
              </div> */}

              {/* OLD TABLE */}

              {/* <div className="wash_tables_wrapper d-flex">
                {oneProduct &&
                  oneProduct.washes.map((wash: any, index: number) => (
                    <table
                      key={index}
                      className={
                        oneProduct.washes.length === 1
                          ? "w-100"
                          : index === oneProduct.washes.length - 1
                          ? "w-50 mr-0"
                          : "w-50 mr-1"
                      }
                    >
                      <tbody>
                        <tr>
                          <th>Wash Type / Dye</th>
                          <td>{wash.name}</td>
                        </tr>
                        {wash.description && (
                          <tr>
                            <th>Description</th>
                            <td
                              style={{
                                wordBreak: "break-word",
                              }}
                            >
                              {wash.description}
                            </td>
                          </tr>
                        )}
                        {wash.colors && (
                          <tr>
                            <th>Colour</th>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {wash.colors.map((color: any, i: number) =>
                                i === wash.colors.length - 1 ? (
                                  <span key={i + index}>
                                    {color?.name || ""}
                                  </span>
                                ) : (
                                  <span key={i + index}>
                                    {color?.name + " • "}
                                  </span>
                                )
                              )}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th>EIM Score</th>
                          <td>{wash.eim_score}</td>
                        </tr>
                        <tr>
                          <th>Price</th>
                          <td>{Math.fround(wash.wash_price).toFixed(2)}€</td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
              </div> */}
              {/* <table style={{ width: "100%" }}>
                <tbody> */}
              {/* {oneProduct && (
                    <> */}
              {/* <tr>
                        <th>Colour</th>
                        <td>
                          {oneProduct.washes.map((wash: any, key: number) => (
                            <>
                              {key > 0 && wash.colors.length > 0 && (
                                <span> / </span>
                              )}
                              {wash.colors.map((color: any, index: number) =>
                                index === wash.colors.length - 1 ? (
                                  <span key={index + key}>
                                    {color?.name || ""}
                                  </span>
                                ) : (
                                  <span key={index + key}>
                                    {color?.name + " • "}
                                  </span>
                                )
                              )}
                            </>
                          ))}
                        </td>
                      </tr> */}
              {/* {oneProduct && (
                        <tr>
                          <th>Type of Wash / Dye</th> */}

              {/* <td>
                            {oneProduct.washes.map((wash: any, key: number) => (
                              <> */}
              {/* {key > 0 &&
                                  oneProduct.washes[key + 1]?.description !==
                                    wash.description && <span> / </span>} */}
              {/* {oneProduct.washes[key + 1]?.description !==
                                  wash.description && (
                                  <span id="wash_desc_table" key={key}>
                                    {wash?.description || ""}{" "}
                                    {key > oneProduct.washes.length - 1 &&
                                      oneProduct.washes[key + 1]
                                        ?.description !== wash.description &&
                                      " • "}
                                  </span>
                                )}
                              </>
                            ))}
                          </td> */}
              {/* </tr>
                      )}
                    </> */}
              {/* )} */}
              {/* {oneProduct && (
                    <tr>
                      <th>Eim Score</th>
                      <td>
                        {oneProduct.washes.map((wash: any, index: number) => (
                          <span key={wash.id}>
                            {wash.eim_score !== 0 && wash.eim_score}{" "}
                            {oneProduct.washes.length - 1 !== index &&
                              oneProduct.washes[index + 1]?.eim_score !== 0 &&
                              " • "}
                          </span>
                        ))}
                      </td>
                    </tr>
                  )} */}

              {/* {oneProduct &&
                    oneProduct.washes.length > 0 &&
                    oneProduct.washes.find((w: any) => w.wash_price) && (
                      <tr>
                        <th>Price </th>
                        {oneProduct && (
                          <td className="pr-5">
                            {oneProduct.washes
                              .filter((el: any) => el.wash_price)
                              .map((el: any, key: number) =>
                                key ===
                                oneProduct.washes.filter(
                                  (el: any) => el.wash_price
                                ).length -
                                  1
                                  ? `${Math.fround(el.wash_price).toFixed(2)}€`
                                  : `${Math.fround(el.wash_price).toFixed(
                                      2
                                    )}€ • `
                              )}
                          </td>
                        )}
                      </tr>
                    )} */}
              {/* </tbody>
              </table> */}
            </div>
            {oneProduct && oneProduct?.fit && (
              <div className="details_fit">
                <h3 className="fit_title">FIT</h3>
                {oneProduct && (
                  <p className="fit_val ml-4">{oneProduct?.fit}</p>
                )}
              </div>
            )}
            <hr />
            <div
              className="total_price_container"
              style={{ marginBottom: "25px !important" }}
            >
              <h3 className="total_price_title">TOTAL PRICE</h3>
              {oneProduct && (
                <p className="total_price">{`${Math.fround(
                  oneProduct?.total_price
                ).toFixed(2)}€`}</p>
              )}
            </div>
          </>
        ) : (
          <>
            <h3 className="wash_title mb-2">Wash</h3>
            <WashTabs
              editMode={editMode}
              washes={oneProduct && oneProduct?.washes}
              oneProduct={oneProduct}
            />
          </>
        )}
        {/* {oneProduct && oneProduct.order_min_qty && (
          <div className="min_qt_container">
            <h3 className="min_qt_title">MOQ</h3>
            <p className="min_qt_val">
              {oneProduct && oneProduct.order_min_qty}
            </p>
          </div>
        )} */}
        {oneProduct && oneProduct?.tags && oneProduct?.tags?.length > 0 ? (
          <div className="tags_container">
            <h3 className="tags_title">TAGS</h3>
            <div className="tag_list">
              {oneProduct &&
                oneProduct?.tags?.map((el: any) => (
                  <Link
                    to={`/products?q=${el?.id}&tag=${el?.name}`}
                    key={el?.id}
                  >
                    <p className="tag">{el?.name}</p>
                  </Link>
                ))}
            </div>
          </div>
        ) : null}
      </div>
      {oneProduct && (
        <>
          <HorizontalProducts
            data={totalLook}
            isLoading={isLoadingTotalLook}
            type={"total-look"}
            fabric={"denim"}
            key={uuidv4()}
          />
          <HorizontalProducts
            data={similarProducts}
            isLoading={isLoadingSimilar}
            type={"similar"}
            fabric={"denim"}
            key={uuidv4()}
          />
        </>
      )}
    </>
  ) : (
    <EditDenimProduct
      oneProduct={oneProduct}
      setEditMode={setEditMode}
      editMode={editMode}
    />
  );
};

export default DenimProduct;
